import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-settlement-plans'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Settlement plans
        </Typography>
        <Typography nextElement='typography'>
          Your beneficiary has several kinds of settlement choices, including lump sum, interest income, period certain for a set number of years, life income plan, Joint Life income plan or the Northwestern Access Fund. Our plans are designed to provide flexibility allowing your beneficiary to preserve your benefit while earning interest, receive income over a specified period, or receive income for their lifetime. Choices are subject to availability and can be discontinued at any time. Plans are subject to individual contracts and market types.
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual offers two basic types of income plans&#8212;fixed and variable. Both offer a number of options. A variable income plan is only available with a variable annuity.
        </Typography>
        <Typography nextElement='typography'>
          The type of settlement choice you select should be based on your financial circumstances, your tolerance of risk and the return potential.
        </Typography>
        <Typography nextElement='typography'>
          See also:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Fixed Income Plans' },
            { bulletText: 'Variable Income Plans' },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
